import { makeStyles } from '@material-ui/core/styles';
import { he } from 'date-fns/locale';
import { RFC_2822 } from 'moment';
import { MapContext } from 'react-mapbox-gl';

export default makeStyles(({ breakpoints: BP }) => ({
  chatContainer: {
    display: 'flex',
    // height: 'calc(100vh - 135px)',
    margin: '0 20px',
    marginTop: '10px',
    height: '89vh',
    gap: 15,
    // maxWidth: '1400px',
    '@media (max-width:1680px)': {
      height: 'auto',
    },
  },
  flowContainer: {
    overflow: 'auto',
    minWidth: 1200,
  },

  chatListContainer: {
    display: 'flex',
    flexDirection: 'column',
    justifyContent: 'space-between',
    width: '20%',
    minWidth: '18%',
    background: '#FFFFFF',
    border: '1px solid #E1E4EA',
    boxShadow: '0px 0px 12px 0px rgba(34, 35, 40, 0.15)',
    borderRadius: 8,
    padding: '0 0px 16px 0px',
    // overflow: 'auto',
    position: 'sticky',
    // top: 81,
    // height: '85.5vh',
    '@media (max-width:1680px)': {
      display: 'none',
    },
  },
  chatListContainerMobile: {
    display: 'none',
    flexDirection: 'column',
    justifyContent: 'space-between',
    width: '300px',
    minWidth: '18%',
    background: '#FFFFFF',
    border: '1px solid #E1E4EA',
    boxShadow: '0px 0px 12px 0px rgba(34, 35, 40, 0.15)',
    borderRadius: 8,
    padding: '0 0px 16px 0px',
    // overflow: 'auto',
    position: 'fixed',
    right: 0,
    bottom: 0,
    height: '88vh',
    zIndex: 1,
    // top: 81,
    // height: '85.5vh',
    '@media (min-width:1680px)': {
      display: 'none',
    },
  },

  chatOpenBtn: {
    position: 'fixed',
    right: '-27px',
    bottom: '80px',
    display: 'flex',
    rotate: '270deg',
    background: '#000',
    color: '#fff',
    padding: '7px 10px',
    borderRadius: '10px 10px 0px 0px',
    cursor: 'pointer',
  },
  chatCloseBtn: {
    display: 'none',
    position: 'fixed',
    right: '275px',
    bottom: '80px',
    rotate: '270deg',
    background: '#000',
    color: '#fff',
    padding: '7px 10px',
    borderRadius: '10px 10px 0px 0px',
    cursor: 'pointer',
  },
  ChatMessageIcon: {
    '& svg': {
      width: '20px',
      height: '20px',
      marginLeft: 8,
      '& path': {
        stroke: '#fff',
      },
    },
  },
  orderDetailsLeft: {
    display: 'flex',
    flexDirection: 'column',
  },
  orderDetailTitle: {
    display: 'flex',
    justifyContent: 'center',
    alignItems: 'center',
    fontSize: '16px',
    fontWeight: 900,
    color: '#3d3d3d',
    marginBottom: '15px',
  },
  row2: {
    display: 'flex',
    alignItems: 'center',
    width: '100%',
  },
  avatar: {
    height: '60px !important',
    width: '60px !important',
    marginRight: '2px !important',
  },
  light2: {
    fontFamily: 'Averta Light',
    fontWeight: 300,
    color: '#3d3d3d',
    width: '60%',
    // overflow: 'hidden',
    whiteSpace: 'nowrap',
    textOverflow: 'ellipsis',
  },
  icon: {
    height: 20,
    width: 20,
    fill: '#f8b100',
    margin: '0 5px',
  },
  companyDetail: {
    display: 'flex',
    justifyContent: 'center',
    alignItems: 'center',
    padding: '10px 0px 20px',
  },
  orderDetail: {
    display: 'flex',
    justifyContent: 'center',
    alignItems: 'center',
    padding: '10px 12px',
    justifyContent: 'space-between',
  },
  textContainer: {
    height: '100%',
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
  },

  messagesContainer: {
    // height: '100%',
    '@media (max-width:1000px)': {
      flex: '1',
    },
  },
  chatMessagesContainer: {
    background: '#FFFFFF',
    border: '1px solid #E1E4EA',
    borderRadius: 8,
    flex: '1',
    // marginRight: '16px',
    position: 'relative',
    // height: 'max-content',
    // overflow: 'auto','
    padding: 20,
    transition: 'all ease 0.3s',
    '@media (min-width:1680px)': {
      overflow: 'auto',
    },

    '&::-webkit-scrollbar-track': {
      transition: 'all 1s ease',
      background: 'transparent',
    },
    '&::-webkit-scrollbar-thumb': {
      transition: 'all 1s ease',
      borderRadius: '5px',
      background: '#dadce4',
    },
    '&::-webkit-scrollbar': {
      transition: 'all 1s ease',
      width: '5px',
    },
    '&::-webkit-scrollbar-thumb:hover': {
      transition: 'all 1s ease',
      background: '#555',
      width: '5px',
    },
    '@media (max-width:1680px)': {
      marginRight: '0',
    },
  },
  tableTopActions: {
    display: 'flex',
    padding: '0px 10px',
    paddingBottom: '16px',
    gap: 10,
    borderBottom: '1px solid #E1E4EA',
    marginBottom: 15,
    fontSize: '18px',
    fontWeight: 900,
  },

  tableTopActionsChatIndex: {
    display: 'flex',
    justifyContent: 'space-between',
    padding: '22px 0px 10px 6px',
    gap: 10,
    borderBottom: '1px solid #e1e4ea',
    marginBottom: 15,
    fontSize: '15px',
    fontWeight: 900,
    position: 'sticky',
    zIndex: 1,
    top: '-30px',
    marginTop: '-20px',
    background: '#fff',
    '& span': {
      display: 'flex',
      alignItems: 'center',
      gap: 10,
    },
  },
  backBtn: {
    cursor: 'pointer',
    padding: '6px 15px',
    borderRadius: '50px',
    transition: 'all ease 0.3s',
    marginBottom: '-4px',
    marginTop: '-8px',
    '& div': {
      display: 'flex',
    },
    '&:hover': {
      background: '#ededed',
    },
  },
  tableTopActionsChat: {
    display: 'flex',
    justifyContent: 'space-between',
    padding: '0px 15px 12px',
    gap: 10,
    borderBottom: '1px solid #e1e4ea',
    alignItems: 'center',
    // marginBottom: 20,
    '& div': {
      padding: 0,
      height: 15,
    },
  },
  tableTopActionsSpan: {
    display: 'flex',
    gap: 10,
    padding: '10px 0 0px',
  },
  searchBox: {
    background: '#FFFFFF',
    border: '1px solid rgba(0, 0, 0, 0.5)',
    borderRadius: '10px',
    height: '40px',
    display: 'flex',
    alignItems: 'center',
    padding: '20px',
    boxSizing: 'border-box',
  },
  searchIcon: {
    fill: 'rgba(0, 0, 0, 0.5)',
  },
  searchInput: {
    border: 'none',
    flex: '1',
    marginLeft: '10px',
    '&::placeholder': {
      color: 'rgba(0, 0, 0, 0.5)',
    },
    '&:focus-visible': {
      border: 'none !important',
      outline: 'none',
    },
  },
  infoChat: {
    display: 'flex',
    flexDirection: 'column',
    justifyContent: 'center',
  },
  topSection: {
    display: 'flex',
    flexDirection: 'row',
    justifyContent: 'space-between',
    border: '1px solid #E1E4EA',
    padding: '16px 24px',
    borderRadius: '8px',
  },
  infoChatDiv: {
    display: 'flex',
    flexDirection: 'row',
    alignItems: 'center',
    gap: 10,
  },
  infoCircleIcon: {
    borderRadius: '8px',
    padding: '8px 10px 6px',
    background: '#F6B51E',
    height: 'max-Content',
  },
  infoCircleIcoRejected: {
    borderRadius: '8px',
    padding: '5px 6px 2px',
    background: '#FB3748',
    border: '1px solid #FB3748',
    height: 'max-Content',
    '& svg': {
      width: 25,
      height: 25,
      '& path': {
        fill: '#fff',
      },
    },
  },
  CountdownSpan: {
    display: 'flex',
  },
  declineBtn: {
    height: 'max-content',
    border: '1px solid #000',
    color: '#000000',
    padding: '4px 12px',
    borderRadius: 8,
  },
  disputeBtn: {
    height: 'max-content',
    border: '1px solid #000',
    color: '#000000',
    padding: '4px 12px',
    borderRadius: 8,
  },
  inputTextArea: {
    width: '96%',
    borderRadius: 8,
    border: '1px solid #E1E4EA',
    padding: 10,
    fontFamily: 'Averta Light',
    '& textarea': {
      fontFamily: 'Averta Light',
      padding: '5px 10px',
    },
  },
  CountdownSpanTitle: {
    padding: '4px 0px',
  },
  // disputeBtn: {
  //   height: 'max-content',
  //   border: '1px solid #780000',
  //   background: '#ff4f4f',
  //   color: '#fff',
  //   padding: '4px 12px',
  //   borderRadius: 8,
  // },
  chatBox: {
    minHeight: '75vh',
    overflow: 'auto',
    display: 'flex',
    flexDirection: 'column',
  },
  rowSection: {
    display: 'flex',
    flexDirection: 'column',
    alignItems: 'center',
    width: '99%',
    padding: '0px 5px',
  },
  removeIcon: {
    padding: '0px',
    borderRadius: '50px',
    '& div': {
      display: 'flex',
    },
  },
  tickIconNew: {
    backgroundColor: '#1FC16B',
    borderRadius: '15px',
    height: '18px',
    width: '20px',
    display: 'flex',
    justifyContent: 'center',
    alignItems: 'center',
    paddingBottom: '2px',
  },
  tickIconBorder: {
    border: '3px solid #d9d9d9',
    borderRadius: '25px',
    marginLeft: '3px',
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    width: '30px',
    height: '30px',
  },
  iconBorder: {
    border: '1.5px solid #99A0AE',
    borderRadius: '25px',
    marginLeft: '5px',
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    width: '30px',
    height: '30px',
  },
  stepsIcon: {
    padding: 5,
    border: '2px solid #d9d9d9',
    borderRadius: 50,
  },
  sectionSpacer: {
    display: 'flex',
    alignItems: 'center',
    width: '100%',
    gap: 7,
  },
  sectionSpacerTitle: {
    width: 'fit-content',
    padding: '6px 16px',
    borderRadius: '50px',
    border: '1px solid #f5f6f7',
    background: '#E7E8EC66',
    color: '#717784',
    fontSize: 14,
  },

  sectionSpacerHr: {
    width: '-webkit-fill-available',
    borderTop: '2px solid #000000',
  },
  sectionDetail: {
    borderLeft: '2px solid #3EE089',
    // marginLeft: 30,
    display: 'flex',
    padding: '20px 0px 28px 24px',
    gap: 20,
    margin: '0px 0px 0px 20px',
    alignItems: 'flex-end',
    width: '-webkit-fill-available',
    overflow: 'auto',
  },
  sectionDetailInprogress: {
    borderLeft: '2px solid #d9d9d9',
    display: 'flex',
    flexDirection: 'column',
    padding: '15px 0px 0px 24px',
    gap: 12,
    alignItems: 'flex-end',
    width: '-webkit-fill-available',
    margin: '0px 0px 0px 20px',
  },
  sectionDetailPassed: {
    borderLeft: '2px solid #3EE089',
    display: 'flex',
    flexDirection: 'column',
    padding: '5px 0px 28px 24px',
    gap: 12,
    alignItems: 'flex-end',
    width: '-webkit-fill-available',
    margin: '0px 0px 0px 20px',
  },
  sectionDetailPreApprove: {
    borderLeft: '2px solid transparent',
    // marginLeft: 30,
    // display: 'flex',
    flexDirection: 'column',
    padding: '15px 0px 15px 24px',
    gap: 20,
    alignItems: 'flex-end',
    width: '100%',
  },
  sectionDetailApprove: {
    borderLeft: '2px solid transparent',
    // marginLeft: 30,
    display: 'flex',
    flexDirection: 'column',
    padding: '15px 0px 15px 24px',
    gap: 12,
    margin: '0px 0px 0px 20px',
    alignItems: 'flex-end',
    width: '-webkit-fill-available',
    overflow: 'auto',
  },

  sectionDetailEmpty: {
    borderLeft: '2px solid #d9d9d9',
    // marginLeft: 30,
    display: 'flex',
    padding: '15px 0px 15px 24px',
    gap: 20,
    alignItems: 'flex-end',
    width: '-webkit-fill-available',
    margin: '0px 0px 0px 20px',
  },
  sectionDetailEmptyEnd: {
    // marginLeft: 30,
    display: 'flex',
    padding: '15px 0px 15px 24px',
    gap: 20,
    alignItems: 'flex-end',
    width: '-webkit-fill-available',
    margin: '0px 0px 0px 20px',
  },

  usersInfoSecton: {
    border: '2px solid #FFE097',
    background: '#FFFAEB',
    display: 'flex',
    flexDirection: 'column',
    justifyContent: 'center',
    alignItems: 'center',
    minHeight: '200px',
    width: '-webkit-fill-available',
    borderRadius: 16,
    padding: '8px 24px',
    fontSize: 13,
    gap: 12,
  },
  CountdownTimerSpan: {
    padding: '4px 0px',
  },
  CountdownDiv: {
    display: 'flex',
    alignItems: 'flex-end',
  },
  usersInfoSectonOffer: {
    border: '2px solid #FFE097',
    background: '#FFFAEB',
    display: 'flex',
    flexDirection: 'column',
    justifyContent: 'center',
    alignItems: 'center',
    minHeight: '110px',
    width: '-webkit-fill-available',
    borderRadius: 16,
    padding: '10px 24px',
    fontSize: 13,
  },
  usersInfoSectonTitle: {
    fontSize: '18px',
    fontWeight: 'bold',
  },
  usersInfoSectonSubTitle: {
    // maxWidth: '65%',
    textAlign: 'center',
  },
  usersInfoSectonBody: {
    maxWidth: '100%',
    textAlign: 'center',
    display: 'flex',
    padding: '0 10px',
  },
  usersInfoSectonBodyRequest: {
    maxWidth: '100%',
    textAlign: 'center',
    display: 'flex',
    padding: '25px 0px 0px',
  },
  usersInfoSectonBodySpan: {
    display: 'flex',
    alignItems: 'center',
    gap: 7,
  },
  usersInfoSectonBodyIcons: {
    display: 'flex',
    // background: '#F5F7FA',
    borderRadius: 8,
    // padding: 6,
  },
  usersInfoSectonBodyTitles: {
    fontWeight: 'bold',
  },
  usersInfoSectonSSlBtn: {
    minWidth: '150px',
    color: '#ffffff',
    padding: '5px 40px',
    border: '1px solid #F6B51E',
    borderRadius: 8,
    margin: '20px 2px',
    lineHeight: '1.3rem',
    background:
      'linear-gradient(0deg, #F6B51E 0%, rgba(255, 255, 255, 0.00) 1868.75%)',
    boxShadow:
      '0px 0px 0px 1px #F6B51E, 0px 1px 1px 0px rgba(14, 18, 27, 0.24)',
    '& span>div>div': {
      display: 'flex',
      gap: 10,
      '& div>div': {
        display: 'flex',
      },
    },
    '&:disabled': {
      // border: '1px solid #F5F7FA',
      boxShadow: 'none',
      background: '#F5F7FA',
      color: '#CACFD8',
    },
  },

  emptyTableHandler: {
    display: 'flex',
    gap: 10,
    flexDirection: 'row',
    justifyContent: 'center',
    alignItems: 'center',
    minHeight: 94,
    width: '-webkit-fill-available',
    border: '1px solid #F4F5F6',
    borderRadius: 4,
  },
  emptyPendingIcon: {
    height: 26,
  },
  emptyChatHandler: {
    display: 'flex',
    flexDirection: 'column',
    justifyContent: 'center',
    alignItems: 'center',
    width: '-webkit-fill-available',
    height: '-webkit-fill-available',
    height: '93%',
  },
  emptyChatIcon: {
    '& svg': {
      width: '100%',
      height: 'auto',
      marginBottom: 15,
    },
  },

  sectionDetailPreAprove: {
    display: 'flex',
    gap: 20,
    width: '95%',
    flexDirection: 'column',
  },
  infoTooltip: {
    padding: '0 !important',
    marginLeft: '-4px',
    marginRight: '-24px',
    '& div': {
      padding: 0,
    },
  },
  tooltipInfo: {
    width: 300,
  },
  tooltipInfoDiv: {
    display: 'flex',
    flexDirection: 'column !important',
  },
  pendingProgress: {
    color: '#999999',
    fontSize: 11,
    fontWeight: 'bold',
  },
  pendingProgressNow: {
    backgroundColor: '#335CFF',
    borderRadius: '20px',
    height: '18px',
    width: '18px',
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
  },
  pendingProgressNowText: {
    color: 'white',
    fontSize: 10,
    fontWeight: 'bold',
  },
  pendingProgressborder: {
    borderRadius: '50%',
    padding: '1px',
    border: '2px solid #335CFF',
    alignItems: 'center',
    display: 'flex',
  },
  pendingSectionSpacerTitle: {
    width: 'fit-content',
    padding: '8px 16px',
    borderRadius: '50px',
    border: '1px solid #E1E4EA',
    // background: '#E8F8F0',
    color: '#717784',
    fontSize: 14,
  },
  list: {
    // margin: '20px 0 0px',
    width: '100%',
    minWidth: '900px',
    border: '1px solid #E1E4EA',
    borderRadius: 4,
    padding: '0px 8px 4px 8px',
  },
  listPopup: {
    margin: '20px 0 0px',
    width: '100%',
    minWidth: '1270px',
    borderRadius: 8,
    padding: '4px 8px',
    display: 'flex',
    flexDirection: 'column',
    gap: 12,
    overflowX: 'auto',
  },

  listPreApprove: {
    // margin: '20px 0 0px',
    width: '100%',
    minWidth: '900px',
    borderRadius: 4,
    padding: '4px 0px 4px 4px',
    display: 'flex',
    flexDirection: 'column',
    gap: 12,
  },
  tableRow: {
    minWidth: 'fit-content',
    display: 'flex',
    flexDirection: 'row',
    alignItems: 'center',
    height: 30,
    borderRadius: 4,
    // boxShadow: '2px 2px 10px 0 rgba(0, 0, 0, 0.2)',
    backgroundColor: '#fff',
    // margin: '10px 0',
    fontFamily: 'Averta',
    fontSize: 12,
    color: '#131517',
    textAlign: 'center',
    '& td': {
      padding: '0 5px',
      borderRight: '1px solid #E8E8E8',
      minHeight: '-webkit-fill-available',
      display: 'flex',
      alignItems: 'center',
      justifyContent: 'center',
      '&:last-child': {
        borderRight: 'none',
      },
    },
    '&:last-child': {
      marginBottom: 0,
    },
    [BP.up('lg')]: {
      fontSize: 11,
    },
    '& div': {
      whiteSpace: 'nowrap',
      // padding: 5,
      // display: 'flex',
    },
  },
  tableRowPreApprove: {
    minWidth: 'fit-content',
    display: 'flex',
    flexDirection: 'row',
    alignItems: 'center',
    height: 50,
    borderRadius: 4,
    border: '1px solid #E1E4EA',
    // boxShadow: '0px 0px 12px 0px #22232826',
    backgroundColor: '#fff',
    // margin: '10px 0',
    fontFamily: 'Averta',
    fontSize: 12,
    // fontWeight: 900,
    color: '#43424b',
    textAlign: 'center',
    '& td': {
      display: 'flex',
      alignItems: 'center',
      width: '100%',
      minHeight: 32,
      justifyContent: 'center',
      borderRight: '1px solid #E8E8E8',
      padding: '0px 5px',
      '&:last-child': {
        borderRight: 'none',
      },
    },
    [BP.up('lg')]: {
      fontSize: 11,
    },
    '& div>div': {
      whiteSpace: 'nowrap',
      width: 'initial',
      // padding: 2,
      // display: 'flex',
      '& .css-1gtu0rj-indicatorContainer': {
        padding: 0,
        // display: 'flex',
      },
    },
    // '&:hover': {
    //   backgroundColor: '#f5f5f5',
    // },
  },
  preApprovePickupLocation: {
    textOverflow: 'ellipsis',
    overflow: 'hidden',
    textWrap: 'nowrap',
    display: 'inline-block !important',
  },
  tableBody: {
    display: 'flex',
    flexDirection: 'column',
    gap: 12,
  },
  tableBodyPopup: {
    display: 'flex',
    flexDirection: 'column',
    gap: 12,
    maxHeight: 400,
    overflowY: 'auto',
  },
  timeSelectSpan: {
    display: 'flex',
    borderRadius: 5,
    border: '1px solid #E1E4EA',
    background: '#FFF',
    padding: 2,
  },
  galleryAddIcon: {
    display: 'flex',
    background: '#F5F7FA',
    borderRadius: 4,
    padding: 5,
  },
  galleryViewIcon: {
    display: 'flex',
    border: '1px solid #335cff',
    borderRadius: 4,
    padding: 5,
    '&:hover': {
      background: '#f3f3f3',
      cursor: 'pointer',
    },
    '& > div:first-child': {
      display: 'flex',
    },
  },
  galleryAddBlueIcon: {
    display: 'flex',
    border: '1px solid #335CFF',
    borderRadius: 4,
    padding: 5,
    '&:hover': {
      background: '#f3f3f3',
      cursor: 'pointer',
    },
    '& > div:first-child': {
      display: 'flex',
    },
  },
  galleryAddedIcon: {
    display: 'flex',
    border: '1px solid #1FC16B',
    borderRadius: 4,
    padding: 4,
    '&:hover': {
      background: '#f3f3f3',
      cursor: 'pointer',
    },
    '& > div:first-child': {
      display: 'flex',
    },
  },
  imageUploadActionBtn: {
    boxShadow: '0px 0px 0px 4px #335CFF1A',
    borderRadius: 4,
    padding: 2,
  },
  imageUploadActionBtnTick: {
    boxShadow: '0px 0px 0px 4px #1FC16B1A',
    borderRadius: 4,
    padding: 2,
  },

  chatList: {
    minHeight: '94.5%',
    // padding: '0px 40px',
    // backgroundSize: "contain",
    // backgroundImage: "url(/static/media/wpback.a2e62ace.jpg)",
    '& > div:first-child': {
      '& > div:first-child': {
        display: 'none',
      },
    },
  },
  containerNumberInput: {
    display: 'flex',
    alignItems: 'center',
    overflow: 'hidden',
  },
  inputContainer: {
    // position: 'absolute',
    width: '100%',
    bottom: '10px',
    display: 'flex',
    justifyContent: 'flex-end',
    gap: 10,
  },
  containerConditions: {
    // background: 'rgba(153, 160, 174, 0.16)',
    borderRadius: 50,
    minWidth: '50%',
    padding: '6px 20px',
  },
  containerInput: {
    display: 'flex',
    alignItems: 'center',
    overflow: 'hidden',
  },
  containerBadge: {
    background: '#e5e5e5',
    height: '100%',
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    fontSize: 12,
    fontWeight: 'bold',
    padding: '0 14px',
    whiteSpace: 'nowrap',
    width: '120px',
    minWidth: '70px',
  },
  input: {
    fontFamily: 'Averta Light',
    width: '100%',
    height: 35,
    backgroundColor: '#fff',
    borderRadius: 8,
    // border: 'solid 1px #707070',
    '& div': {
      borderRadius: 8,
      '& fieldset': {
        borderRadius: 8,
        border: 'transparent',
      },
    },
    '& input': {
      fontFamily: 'Averta Light',
      padding: '9px 10px',
      fontSize: 11,
      borderRadius: 8,
      border: '1px solid #E1E4EA',
      '&:disabled': {
        background: '#F5F7FA',
        color: '#CACFD8',
        border: 'transparent',
      },
    },
  },

  containerSelectBtn: {
    display: 'flex',
    gap: 8,
    minWidth: '60px',
    justifyContent: 'space-between',
    alignItems: 'center',
    padding: '6px 12px',
    borderRadius: 8,
    cursor: 'pointer',
    border: '1px solid #E1E4EA',
    background: '#FFF',
    '&:hover': {
      background: '#f3f3f3',
      cursor: 'pointer',
    },
  },
  containerPending: {
    display: 'flex',
    gap: 1,
    justifyContent: 'center',
    alignItems: 'center',
    padding: '3px 10px',
    borderRadius: 50,
    color: '#717784',
    background: '#99A0AE29',
    fontSize: '10px',
  },
  tableRowSelectable: {
    minWidth: 'fit-content',
    display: 'flex',
    flexDirection: 'row',
    alignItems: 'center',
    height: 50,
    borderRadius: 8,
    border: '1px solid #E1E4EA',
    backgroundColor: '#fff',
    fontFamily: 'Averta',
    fontSize: 11,
    fontWeight: 500,
    color: '#43424b',
    textAlign: 'center',
    '&:last-child': {
      marginBottom: 0,
    },
    '& td': {
      display: 'flex',
      alignItems: 'center',
      width: '100%',
      justifyContent: 'center',
      borderRight: '1px solid #E8E8E8',
      padding: '0px 6px',
    },
    [BP.up('lg')]: {
      fontSize: 11,
    },
    '& div': {
      whiteSpace: 'nowrap',
      padding: 5,
      display: 'flex',
    },
    '&:hover': {
      background: '#f3f3f3',
      cursor: 'pointer',
    },
  },
  checkbox: {
    marginRight: '10px',
    padding: 5,
    '& svg': {
      fill: '#000',
      width: '20px',
    },
    '& hover': {
      background: '#f8b1001a',
    },
  },
  tableRowSelected: {
    minWidth: 'fit-content',
    display: 'flex',
    flexDirection: 'row',
    alignItems: 'center',
    height: 50,
    borderRadius: 8,
    border: '1px solid #335CFF',
    boxShadow: '0px 0px 12px 0px rgba(0, 0, 0, 0.15)',
    backgroundColor: '#EBF1FF',
    fontFamily: 'Averta',
    fontSize: 11,
    fontWeight: 500,
    color: '#43424b',
    textAlign: 'center',
    '&:last-child': {
      marginBottom: 0,
    },
    '& td': {
      display: 'flex',
      alignItems: 'center',
      width: '100%',
      justifyContent: 'center',
      borderRight: '1px solid #E8E8E8',
      padding: '0px 6px',
    },
    [BP.up('lg')]: {
      fontSize: 11,
    },
    '& div': {
      whiteSpace: 'nowrap',
      padding: 5,
      display: 'flex',
    },
  },

  thead: {
    display: 'flex',
    fontFamily: 'Averta light',
    fontSize: 11,
    // fontWeight: 600,
    // lineHeight: 1.2,
    color: '#999999',
    textAlign: 'center',
    borderBottom: '1px solid #E8E8E8',
    alignItems: 'center',
    height: '40px',
    '& th': {
      padding: '2px 5px 0px',
      borderRight: '1px solid #E8E8E8',
      display: 'flex',
      alignItems: 'center',
      height: '100%',
      justifyContent: 'center',
      '&:last-child': {
        borderRight: 'none',
      },
      ['.MuiTooltip-tooltip']: {
        maxWidth: '500px',
      },
    },
    [BP.up('lg')]: {
      fontSize: 11,
    },
    '& div': {
      whiteSpace: 'nowrap',
      padding: 5,
    },
  },
  theadPreApprove: {
    display: 'flex',
    fontFamily: 'Averta light',
    fontSize: 12,
    // fontWeight: 600,
    // lineHeight: 1.2,
    color: '#525866',
    textAlign: 'center',
    border: '1px solid #E8E8E8',
    borderRadius: '4px 4px 0px 0px',
    boxShadow:
      '0px 2px 4px -2px rgba(24, 39, 75, 0.12), 0px 4px 4px -2px rgba(24, 39, 75, 0.08)',
    alignItems: 'center',
    height: '52px',
    '& th': {
      padding: '0px 5px 0px',
      borderRight: '1px solid #E8E8E8',
      display: 'flex',
      alignItems: 'center',
      height: '100%',
      justifyContent: 'center',
      '&:last-child': {
        borderRight: 'none',
      },
    },
    [BP.up('lg')]: {
      fontSize: 11,
    },
    '& div': {
      whiteSpace: 'nowrap',
      padding: 5,
    },
  },
  tbody: {
    // display: 'flex',
    // flexDirection: 'column',
    // width:'fit-content'
  },

  loading: {
    position: 'absolute',
    top: '0',
    right: '0',
    left: '0',
    bottom: '0',
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
  },

  modal: {
    width: '100%',
    height: '100%',
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
  },
  modalBox: {
    width: '400px',
    minHeight: '397px',
    background: '#FFFFFF',
    borderRadius: '5px',
    padding: '10px 15px',
    display: 'flex',
    flexDirection: 'column',
    justifyContent: 'space-between',
  },
  closeModal: {
    textAlign: 'end',
    '& img': {
      width: '10px',
      height: '10px',
      cursor: 'pointer',
    },
  },
  modalTitle: {
    fontWeight: 'bold',
    fontSize: '20px',
    lineHeight: '23px',
    color: '#000000',
    margin: '0 0 20px 0',
  },
  containersTableContainer: {
    maxHeight: '300px',
    overflow: 'auto',
    flex: '1',
  },
  popup: {
    // position: 'absolute',
    left: 90,
    right: 0,
    top: 0,
    bottom: 0,
    padding: '0px 10px',
    background: 'rgba(19, 21, 23, 0.40)',
    backdropFilter: 'blur(6px)',
    zIndex: 999,
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    position: 'fixed',
    '@media (max-width: 830px)': {
      left: 0,
      padding: '10px',
    },
  },

  card: {
    width: 1420,
    position: 'relative',
    padding: 24,
    display: 'flex',
    flexDirection: 'column',
    justifyContent: 'space-evenly',
    borderRadius: 16,
    border: '1px solid #E8E8E8',
    boxShadow: '2px 2px 10px 0 rgba(0, 0, 0, 0.2)',
    backgroundColor: '#fff',
    boxSizing: 'border-box',
    maxHeight: '620px',
    overflow: 'auto',
    '@media (max-width: 830px)': {
      width: '95vw',
      maxWidth: '95vw',
      margin: '0 auto',
      maxHeight: 'unset',
    },
  },

  cardContent: {
    minWidth: 620,
    '@media (max-width: 830px)': {
      minWidth: 300,
    },
  },

  uploadImageCard: {
    width: '650px',
    position: 'relative',
    padding: 24,
    display: 'flex',
    flexDirection: 'column',
    justifyContent: 'space-evenly',
    borderRadius: 16,
    boxShadow: '2px 2px 10px 0 rgba(0, 0, 0, 0.2)',
    backgroundColor: '#fff',
    boxSizing: 'border-box',
    maxHeight: '84.5%',
    '@media (max-width: 830px)': {
      width: '100%',
    },
  },
  loading: {
    height: '100%',
    margin: 0,
  },
  imageUploadSection: {
    display: 'flex',
    justifyContent: 'center',
    alignItems: 'center',
    flexDirection: 'column',
    // gap: '10px',
    margin: '15px 0 0',
    border: '1.5px dashed #99A0AE',
    borderRadius: 20,
    height: '180px',
    width: '100%',
  },
  imageUploadArea: {
    marginTop: '-10px',
    display: 'flex',
    flexDirection: 'column',
    justifyContent: 'center',
    alignItems: 'center',
    gap: '10px',
  },
  imageUploadIcon: {
    marginTop: '-25px',
    '& svg': {
      width: '140px',
      height: '90px',
    },
  },
  dragDropText: {
    fontSize: '20px',
    color: '#131517',
    fontWeight: 900,
  },
  dragDropOrText: {
    display: 'flex',
    justifyContent: 'center',
    alignItems: 'center',
    width: '400px',
    flexDirection: 'row',
    fontSize: 12,
    color: '#999',
    fontWeight: 300,
    gap: 10,
  },
  orHr: {
    width: '80px',
    borderTop: '1px solid #E1E4EA',
  },
  fileTypeInfo: {
    fontSize: 12,
    color: '#99A0AE',
    fontWeight: 400,
  },
  browFilesBtn: {
    border: '1px solid #FFAD00',
    color: '#FFAD00',
    borderRadius: 8,
    padding: '5px 22px 7px',
    background: 'transparent',
    cursor: 'pointer',
    '&:hover': {
      background: '#eeeeee',
    },
  },
  imagesDiv: {
    display: 'flex',
    flexDirection: 'column',
    gap: 10,
    marginTop: 15,
    maxHeight: '265px',
    overflow: 'auto',
  },
  imagePreviewDiv: {
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'space-between',
    padding: '12px 16px',
    borderRadius: 12,
    border: '1px solid #E1E4EA',
    position: 'relative',
  },
  uploadedImagesDiv: {
    display: 'flex',
    // flexDirection: 'column',
    gap: 10,
    marginTop: 15,
    maxHeight: '280px',
    // overflow: 'auto',
    flexWrap: 'wrap',
  },
  uploadedImagePreviewDiv: {
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'space-between',
    padding: '0',
    borderRadius: 12,
    border: '1px solid #E1E4EA',
    position: 'relative',
    width: '48.8%',
    overflow: 'hidden',
  },
  imagePreviewImg: {
    width: '60px',
    height: '60px',
    borderRadius: '8px 0px 0px 8px',
    objectFit: 'cover',
  },
  imageRemoveIcon: {
    '& svg': {
      width: 24,
      height: 24,
    },
  },
  uploadedImageRemoveIcon: {
    color: '#fb3748',
    gap: 5,
    display: 'flex',
    padding: '4px 10px 0px',
    transition: 'all ease 0.3s',
    cursor: 'pointer',
    borderRadius: 5,
    fontSize: 12,
    '& svg': {
      width: 18,
      height: 18,
    },
    '&:hover': {
      background: '#ececec',
    },
  },
  uploadedImageViewIcon: {
    color: '#335cff',
    gap: 5,
    display: 'flex',
    padding: '4px 10px 0px',
    transition: 'all ease 0.3s',
    borderRadius: 5,
    cursor: 'pointer',
    fontSize: 12,
    '& svg': {
      width: 18,
      height: 18,
    },
    '&:hover': {
      background: '#ececec',
    },
  },
  SelectedImageIcons: {
    display: 'flex',
    justifyContent: 'space-between',
    alignItems: 'center',
  },
  UploadeImageIcons: {
    display: 'flex',
    justifyContent: 'flex-end',
    gap: 5,
  },
  imagePreviewInfoSection: {
    display: 'flex',
    gap: 6,
    width: '100%',
    paddingRight: 6,
  },
  imagePreviewInfo: {
    display: 'flex',
    flexDirection: 'column',
    justifyContent: 'space-around',
    color: '#999999',
    width: '100%',
    fontSize: '12px',
  },
  imagePreviewName: {
    display: 'inline-block',
    overflow: 'hidden',
    maxWidth: '400px',
    whiteSpace: 'nowrap',
    textOverflow: 'ellipsis',
    flexDirection: 'column',
    justifyContent: 'space-around',
    color: '#131517',
    fontWeight: 600,
  },
  UploadedmagePreviewName: {
    display: 'inline-block',
    overflow: 'hidden',
    maxWidth: '215px',
    whiteSpace: 'nowrap',
    textOverflow: 'ellipsis',
    flexDirection: 'column',
    justifyContent: 'space-around',
    color: '#131517',
    fontSize: '12px',
  },
  textCounterTitle: {
    fontSize: '14px',
    fontFamily: 'averta',
    width: '80%',
  },
  textCounterTitles: {
    paddingRight: '15px',
  },
  numberCounterTitle: {
    paddingRight: '12px',
    fontSize: '11px',
    fontFamily: 'averta',
    minWidth: 70,
    textAlign: 'center',
  },
  preApproveTableTitle: {
    paddingRight: '12px',
    paddingLeft: '5px',
    fontSize: '14px',
    fontFamily: 'averta',
    minWidth: 70,
  },
  numbercounter: {
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    gap: '10px',
    fontFamily: 'Averta',
    fontSize: '18px',
  },
  numberbutton: {
    width: '25px',
    minWidth: '25px',
    height: '25px',
    border: '1px solid #000000',
    borderRadius: '6px',
    backgroundColor: 'white',
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    cursor: 'pointer',
    fontSize: '18px',
    color: '#000000',
    transition: 'background-color 0.2s',
    padding: '8px',
  },
  numberbuttonDisable: {
    width: '25px',
    minWidth: '25px',
    padding: '0px 2px 2px 0px',
    height: '25px',
    border: '1px solid #99A0AE',
    borderRadius: '6px',
    backgroundColor: 'white',
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    cursor: 'pointer',
    fontSize: '18px',
    color: '#99A0AE',
    transition: 'background-color 0.2s',
    padding: '6px',
  },
  numbervalue: {
    fontWeight: 'bold',
  },

  closePx: {
    position: 'absolute',
    bottom: '-10px',
    right: '-5px',
    height: 25,
    cursor: 'pointer',
    fill: '#e4464b',
  },
  closeP: {
    position: 'absolute',
    top: '8px',
    right: '9px',
    height: 25,
    cursor: 'pointer',
    fill: '#e4464b',
  },
  msgPopupBtns: {
    display: 'flex',
    // minWidth: 980,
    justifyContent: 'flex-end',
    gap: 10,
  },
  containerSelectPopupBtns: {
    display: 'flex',
    // minWidth: 1340,
    padding: '5px 8px',
    justifyContent: 'flex-end',
    gap: 8,
    marginTop: 8,
  },
  declinePopupBtns: {
    display: 'flex',
    justifyContent: 'center',
    gap: 10,
  },
  disputePopupBtns: {
    display: 'flex',
    justifyContent: 'flex-end',
  },
  declineTextSpan: {
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    fontSize: '17px',
    fontWeight: 600,
  },
  disputeTextSpan: {
    display: 'flex',
    fontSize: '15px',
    // fontWeight: 600,
    flexDirection: 'column',
  },
  disputeTex: {
    marginBottom: '20px',
  },
  inputGroup: {
    display: 'flex',
    alignItems: 'center',
    marginBottom: '3px',
    fontFamily: 'averta light',
  },
  inputGroupWithLine: {
    display: 'flex',
    alignItems: 'center',
    marginBottom: '10px',
    borderBottom: '1px solid #d0d0d0',
  },
  checkbox: {
    marginRight: '10px',
    padding: 5,
    '& svg': {
      fill: '#000',
      width: '20px',
    },
    '& hover': {
      background: '#f8b1001a',
    },
  },

  label: {
    display: 'flex',
    alignItems: 'center',
    gap: '10px',
    flex: '1',
    fontWeight: 'bold',
  },

  numberSelectDiv: {
    display: 'flex',
    justifyContent: 'space-between',
    alignItems: 'center',
    width: '-webkit-fill-available',
    // padding: '0px 10px',
  },

  numberSelectSpan: {
    display: 'flex',
    justifyContent: 'flex-start',
    border: '1px solid #E8E8E8',
    borderRadius: 10,
    fontSize: 11,
    padding: '4px 12px',
    boxShadow: '0px 1px 2px 0px rgba(14, 18, 27, 0.03)',
  },
  select: {
    width: '100%',
    fontFamily: 'Averta Light',
    borderRadius: 8,
    '& > div': {
      // border: 'solid 1px #707070',
      minHeight: 32,
      borderRadius: 8,
      // height: 29,
      // flexWrap: 'nowrap',
    },
    '& > div:first-child > div': {
      padding: '0 0 0 10px',
      height: 32,
    },
    '& > div:first-child': {
      background: 'transparent',
    },
    // '& svg': {
    //   fill: '#f8b100',
    // },
    '& input': {
      '&:disabled': {
        background: '#F5F7FA',
        color: '#CACFD8',
        border: 'transparent',
      },
    },
  },
  date: {
    boxSizing: 'border-box',
    width: '100%',
    backgroundColor: '#fff',
    borderRadius: 4,
    justifyContent: 'center',
    fontFamily: 'Averta Light',
    '& input': {
      width: '100%',
      padding: 0,
      cursor: 'pointer',
      fontFamily: 'Averta Light',
      height: 28.5,
      border: 'none',
    },
    '& svg': {
      fill: '#f8b100',
    },
    '& button': {
      padding: 8,
    },
  },
  loc: {
    '& svg': {
      fill: '#f8b100',
    },

    fontFamily: 'Averta Light',
    width: '100%',
    height: 29,
    backgroundColor: '#fff',
    borderRadius: 5,
    justifyContent: 'center',
    '& input': {
      padding: '5px 10px',
      fontFamily: 'Averta Light',
    },
    '& > div': {
      // border: 'solid 1px #707070',
      width: 'auto',
      textAlign: 'justify',
      minWidth: '-webkit-fill-available',
      maxWidth: '320px',
      minHeight: 29,
    },
    '& > div:first-child > div': {
      padding: '0 0 0 10px',
      height: 29,
      height: 29,
    },
  },

  imageUploadBtn: {
    color: '#ffffff !important',
    background: '#f8b100',
    padding: 5,
    // marginTop: '10px',
    margin: '2px',
    width: '95px',
    lineHeight: '1.3rem',
    '&:hover': {
      background: '#ce9300',
      color: '#ffffff',
    },
    '&:disabled': {
      background: '#e4e4e4',
      color: '#bcbcbc !important',
    },
  },

  saveBtn: {
    color: '#ffffff',
    background: '#0074F8',
    padding: 8,
    marginTop: '10px',
    margin: '2px',
    width: '95px',
    lineHeight: '1.3rem',
    '&:hover': {
      background: '#0057b9',
      color: '#ffffff',
    },
  },
  preApproveBtn: {
    color: '#ffffff',
    padding: '5px 18px',
    border: '1px solid rgba(82, 88, 102, 0.50)',
    borderRadius: 10,
    marginTop: '8px',
    margin: '2px',
    lineHeight: '1.3rem',
    minWidth: 140,
    background:
      'linear-gradient(0deg, #0E121B 55.7%, rgba(255, 255, 255, 0.00) 736.46%)',
    boxShadow:
      '0px 0px 0px 1px #242628, 0px 1px 2px 0px rgba(27, 28, 29, 0.48)',
    '& span>div>div': {
      display: 'flex',
      gap: 10,
      '& div>div': {
        display: 'flex',
      },
    },
    '&:disabled': {
      // border: '1px solid #F5F7FA',
      boxShadow: 'none',
      background: '#F5F7FA',
      color: '#CACFD8',
    },
    '& >span': {
      display: 'flex',
    },
    '& >span>div': {
      width: '21px !important',
      height: '25px !important',
    },
    '& svg': {
      width: '21px',
      paddingRight: 5,
      '& circle': {
        stroke: '#fff',
      },
    },
  },
  cunfirmBtn: {
    color: '#1FC16B',
    padding: '2px 6px',
    border: '1px solid #1FC16B',
    borderRadius: 10,
    marginTop: '8px',
    margin: '2px',
    lineHeight: '1.3rem',
    background: 'transparent',
    fontSize: 10,
    '& span>div>div': {
      display: 'flex',
      gap: 10,
      '& div>div': {
        display: 'flex',
      },
    },
  },
  requiredField: {
    color: '#f00',
    fontSize: 20,
  },

  declineBtn: {
    color: '#ffffff',
    padding: '0px 20px',
    height: 35,
    border: '1px solid #FB3748',
    borderRadius: 10,
    marginTop: '8px',
    margin: '2px',
    lineHeight: '1.3rem',
    background: '#FB3748',
    fontSize: 15,
    '& span>div>div': {
      display: 'flex',
      gap: 10,
      '& div>div': {
        display: 'flex',
      },
    },
    '&:hover': {
      background: '#ff0000',
    },
  },
  declinedBtn: {
    color: '#fb3748',
    padding: '2px 10px',
    border: '1px solid #FB3748',
    borderRadius: 10,
    marginTop: '8px',
    margin: '2px',
    lineHeight: '1.3rem',
    background: '#FB3748',
    fontSize: 10,
    '& span>div>div': {
      display: 'flex',
      gap: 10,
      '& div>div': {
        display: 'flex',
      },
    },
  },

  submitBtn: {
    color: '#000',
    background: '#FFAD00',
    borderRadius: 4,
    padding: '8px 15px',
    marginTop: '10px',
    margin: '2px',
    border: '1px solid #FFAD00',
    width: 'max-content',
    lineHeight: '1.3rem',
    minWidth: '115px',
    '& >span>div': {
      width: '21px !important',
      height: '21px !important',
    },
    '& svg': {
      width: '21px',
    },
  },
  cancelBtn: {
    color: '#000',
    background: 'transparent',
    borderRadius: 4,
    padding: '6px 20px',
    border: '1px solid #000',
    marginTop: '10px',
    margin: '2px',
    width: 'max-content',
    minWidth: '115px',
    lineHeight: '1.3rem',
    // '&:hover': {
    //   background: '#0057b9',
    //   color: '#ffffff',
    // },
  },
  confirmedText: {
    color: '#1FC16B',
    background: '#E8F8F0',
    borderRadius: 50,
    padding: '6px 15px',
  },
  declinedText: {
    color: '#FB3748',
    background: '#FECFD3',
    borderRadius: 60,
    padding: '6px 11px',
    width: '60px',
  },
  boxContainer: {
    display: 'flex',
    gap: '10px',
    justifyContent: 'center',
    width: '60px',
  },
  imagesForUpload: {
    display: 'flex',
    flexDirection: 'row',
    gap: '10px',
    padding: '25px',
  },
  box: {
    width: '100px',
    height: '120px',
    border: '1px dashed #ccc',
    position: 'relative',
    cursor: 'pointer',
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    flexDirection: 'column',
  },
  addIcon: {
    width: '100%',
    height: '100%',
    fontSize: '24px',
    lineHeight: '50px',
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
  },
  boxPreview: {
    width: '100%',
    height: '100%',
    backgroundSize: 'cover',
    backgroundPosition: 'center',
    borderRadius: '5px',
  },
  zoomIcon: {
    position: 'absolute',
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    width: '100%',
    top: 0,
    height: '75%',
    background: 'rgba(0, 0, 0, 0.5)',
    color: 'white',
    padding: '5px',
    cursor: 'pointer',
    display: 'none',
  },
  modal: {
    display: 'none',
    position: 'fixed',
    zIndex: 1000,
    left: 0,
    top: 0,
    width: '100%',
    height: '100%',
    backgroundColor: 'rgba(0, 0, 0, 0.8)',
    alignItems: 'center',
    justifyContent: 'center',
  },
  modalContent: {
    margin: 'auto',
    display: 'block',
    maxHeight: '80vh',
  },
  addBox: {
    width: '100px',
    height: '100px',
    border: '1px dashed #ccc',
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    fontSize: '24px',
    color: '#888',
    cursor: 'pointer',
    transition: 'background-color 0.3s ease, color 0.3s ease',
    '&:hover': {
      backgroundColor: '#f0f0f0',
      color: '#555',
    },
  },

  imagePopup: {
    display: 'flex',
    background: '#d1d1d1',
    borderRadius: 8,
    position: 'relative',
    padding: '40px 15px 15px',
  },
  close: {
    position: 'absolute',
    top: '-5px',
    right: '25px',
    color: 'red',
    fontSize: '35px',
    fontWeight: 'bold',
    cursor: 'pointer',
  },
  uploadBtn: {
    color: '#ffffff',
    background: '#f8b100',
    padding: '5px',
    margin: '2px',
    width: '95px',
    lineHeight: '1.3rem',
    '&:hover': {
      background: '#ce9300',
      color: '#ffffff',
    },
    '&:disabled': {
      background: '#e4e4e4',
      color: '#bcbcbc',
    },
  },

  containerTime: {
    position: 'relative',
    width: 'fit-content',
  },
  inputTime: {
    padding: '10px 15px',
    border: '1px solid #ddd',
    borderRadius: '8px',
    cursor: 'pointer',
    fontSize: '14px',
    width: '200px',
    textAlign: 'center',
  },
  popupTime: {
    position: 'absolute',
    top: '40px',
    left: '0',
    border: '1px solid #ddd',
    borderRadius: '8px',
    background: '#fff',
    boxShadow: '0 4px 10px rgba(0, 0, 0, 0.1)',
    padding: '10px',
    zIndex: 1000,
    display: 'flex',
    flexDirection: 'column',
    alignItems: 'center',
    gap: '15px',
  },
  sectionTime: {
    width: '150px',
  },
  labelTime: {
    display: 'block',
    fontSize: '14px',
    marginBottom: '5px',
  },
  timePickerTime: {
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'space-between',
    gap: '5px',
    padding: '8px',
    border: '1px solid #ddd',
    borderRadius: '8px',
  },
  buttonTime: {
    background: 'transparent',
    border: 'none',
    fontSize: '18px',
    cursor: 'pointer',
  },
  amPmButtonTime: {
    background: 'transparent',
    border: 'none',
    fontSize: '14px',
    padding: '5px',
    cursor: 'pointer',
  },
  hourTextTime: {
    fontSize: '16px',
    fontWeight: 'bold',
  },
  setTimeButtonTime: {
    marginTop: '10px',
    padding: '8px 20px',
    border: 'none',
    background: '#007bff',
    color: '#fff',
    borderRadius: '5px',
    fontSize: '14px',
    cursor: 'pointer',
  },
  longtext: {
    display: '-webkit-box',
    WebkitBoxOrient: 'vertical',
    WebkitLineClamp: 2,
    overflow: 'hidden',
    textOverflow: 'ellipsis',
  },
  warning: {
    color: '#000',
    fontSize: '10px',
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'flex-start',
    marginRight: '4px',
    marginTop: '4px',
  },
  popupCards: {
    maxHeight: '500px',
    overflowY: 'auto',
  },
}));
